<template>
  <div class="d-flex flex-grow-1 inherit-height">
    <div class="flex-grow-1">
      <slot name="asideContent"></slot>
    </div>
    <CSidebar class="asideBar bg-white inherit-height" aside :show="showSidebar" colorScheme="light" size="xl">
      <CSidebarHeader class="d-flex justify-content-between align-items-center bg-white border-top border-bottom p-3">
        <span class="font-2xl font-weight-bold">{{ title }}</span>
        <CSidebarClose @click.native="closeSidebar" />
      </CSidebarHeader>
      <slot name="collapsedContent"></slot>
    </CSidebar>
  </div>
</template>

<script>
export default {
  name: 'AutomationSidebar',
  props: {
    title: {
      type: String,
    },
    showSidebar: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeSidebar() {
      this.$emit('closeSidebar')
    },
  },
}
</script>

<style lang="scss" scoped>
.asideBar {
  position: relative;
  bottom: initial;
  height: 100%;
  overflow-y: auto;
  border: 0;
  box-shadow: none !important;
  overflow-x: none;
  z-index: 1028;

  .c-sidebar-nav {
    padding-bottom: 0;
  }

  .minimizer {
    position: relative;
  }
}

.inherit-height {
  height: inherit;
  min-height: inherit;
}
</style>
